import {Utils} from "./Utils";

export interface CookiesConfig {
    popup: HTMLElement;
    trigger: HTMLElement;
    cookie: string;
    timeout?: number;
}

export class CookiesWarning {
    private readonly elements: {
        popup: HTMLElement;
        trigger: HTMLElement;
    };
    public cookie: string;
    public timeout: number;

    constructor({popup, trigger, cookie, timeout = 1000}: CookiesConfig) {
        this.elements = {popup, trigger};
        this.cookie = cookie;
        this.timeout = timeout;
        this.init();
    }

    public hide(): void {
        localStorage.setItem(this.cookie, `1`);
        Utils.fadeOut(this.elements.popup, 400);
    }

    protected onAcceptKeyPressing(evt: KeyboardEvent): void {
        if (evt.key === `Enter`) this.hide();
    }

    protected bind(): void {
        this.elements.trigger.addEventListener('click', () => this.hide());
        this.elements.trigger.addEventListener('keydown', (evt) => this.onAcceptKeyPressing(evt));
    }

    protected init(): void {
        if (!this.elements.popup) return;

        if (localStorage.getItem(this.cookie) !== `1`) {
            setTimeout( () => {
                this.elements.popup.classList.add(`is-opened`);
                this.bind();
            }, this.timeout)
        }
    }
}